import React, { useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button,
  Form
} from "reactstrap";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import TableContainer from "../../../components/Common/TableContainer";
// Custom styles
const SelectcustomStyles = {
  control: (base) => ({
    ...base,
    minHeight: 33.1,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
};
const categoryOptions = [
  { value: "Executive", label: "Executive" },
  { value: "Admin Staff", label: "Admin Staff" },
  { value: "Driver", label: "Driver" },
  { value: "Technical Staff", label: "Technical Staff" },
  { value: "Maintenance", label: "Maintenance" },
];

const departmentOptions = [
  { value: "HR", label: "Human Resources" },
  { value: "Finance", label: "Finance" },
  { value: "IT", label: "Information Technology" },
  { value: "Operations", label: "Operations" },
  { value: "Logistics", label: "Logistics" },
];

const designationOptions = [
  { value: "Manager", label: "Manager" },
  { value: "Senior Executive", label: "Senior Executive" },
  { value: "Assistant", label: "Assistant" },
  { value: "Supervisor", label: "Supervisor" },
  { value: "Intern", label: "Intern" },
];

const financialYearOptions = [
  { value: "2025-2026", label: "2025-2026" },
];

const ManagerAppraisal = () => {
  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      designation: "",
      financialYear: "",
      employeeCode: "",
      employeeName: "",
    },
    validationSchema: Yup.object({
      category: Yup.string().required("Category is required"),
      department: Yup.string().required("Department is required"),
      designation: Yup.string().required("Designation is required"),
      financialYear: Yup.string().required("Financial Year is required"),
    }),
    onSubmit: (values) => {
      console.log("Searching with values:", values);
    },
  });

  const data = [
    {
      sno: 1,
      code: "0",
      name: "AES ADMIN",
      category: "Admin",
      department: "Admin",
      designation: "General admin",
      finYear: "2024-2025",
      joinDate: "03.04.24",
    },
    {
      sno: 2,
      code: "369",
      name: "MAHESH",
      category: "Admin",
      department: "Admin",
      designation: "Apprentice",
      finYear: "2024-2025",
      joinDate: "15.01.24",
    },
    {
      sno: 3,
      code: "019",
      name: "KARTHI R",
      category: "Staff",
      department: "PRODUCTION",
      designation: "Production Supervisor",
      finYear: "2024-2025",
      joinDate: "31.12.23",
    },
  ];

  const columns = useMemo(
    () => [
      {
        Header: "S.No", Cell: ({ row }) => data.length - row.index, className: "serial-no",
        applyHeaderClass: true,
      },
      { Header: "Code", accessor: "code" },
      { Header: "Name", accessor: "name" },
      { Header: "Category", accessor: "category" },
      { Header: "Department", accessor: "department" },
      { Header: "Designation", accessor: "designation" },
      { Header: "Fin Year", accessor: "finYear" },
      { Header: "Join Date", accessor: "joinDate" },
      {
        Header: "Action",
        className: "status-col",
        applyHeaderClass: true,
        Cell: ({ row }) => (
          <Button
            color="dark"
            size="sm">
            <i className="fas fa-th-list"></i>
          </Button>
        ),
      },
    ],
  );

  return (
    <div className="page-content">
      <Container fluid className="mt-4">
        <Breadcrumbs title="Performance" breadcrumbItem="Manager Appraisal" />
        <Card className="shadow-sm">
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col xs={12} md={4}>
                  <FormGroup>
                    <Label>Category</Label>
                    <Select
                      options={categoryOptions}
                      name="category"
                      placeholder="--Select--"
                      value={categoryOptions.find(opt => opt.value === formik.values.category)}
                      onChange={(option) => formik.setFieldValue("category", option?.value || "")}
                      onBlur={formik.handleBlur}
                      isMulti
                      styles={SelectcustomStyles}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.category && formik.errors.category && (
                      <div className="text-danger">{formik.errors.category}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <Label>Department</Label>
                    <Select
                      options={departmentOptions}
                      name="department"
                      placeholder="--Select--"
                      value={departmentOptions.find(opt => opt.value === formik.values.department)}
                      onChange={(option) => formik.setFieldValue("department", option?.value || "")}
                      onBlur={formik.handleBlur}
                      isMulti
                      styles={SelectcustomStyles}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.department && formik.errors.department && (
                      <div className="text-danger">{formik.errors.department}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <Label>Designation</Label>
                    <Select
                      options={designationOptions}
                      name="designation"
                      placeholder="--Select--"
                      value={designationOptions.find(opt => opt.value === formik.values.designation)}
                      onChange={(option) => formik.setFieldValue("designation", option?.value || "")}
                      onBlur={formik.handleBlur}
                      isMulti
                      styles={SelectcustomStyles}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.designation && formik.errors.designation && (
                      <div className="text-danger">{formik.errors.designation}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <Label>Financial Year <span className="text-danger">*</span></Label>
                    <Select
                      options={financialYearOptions}
                      name="financialYear"
                      placeholder="--Select--"
                      value={financialYearOptions.find(opt => opt.value === formik.values.financialYear)}
                      onChange={(option) => formik.setFieldValue("financialYear", option?.value || "")}
                      onBlur={formik.handleBlur}
                      styles={SelectcustomStyles}
                      className="hrms-select"
                      classNamePrefix="hrms-select"
                    />
                    {formik.touched.financialYear && formik.errors.financialYear && (
                      <div className="text-danger">{formik.errors.financialYear}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <Label>Employee Code</Label>
                    <Input
                      name="employeeCode"
                      value={formik.values.employeeCode}
                      onChange={formik.handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12} md={4}>
                  <FormGroup>
                    <Label>Employee Name</Label>
                    <Input
                      name="employeeName"
                      value={formik.values.employeeName}
                      onChange={formik.handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col xs={12}>
                  <p className="text-danger fw-bold">
                    CAUTION : Please ensure all the pending compensation leaves were approved.
                  </p>
                </Col>
                <Col xs={12} className="d-flex justify-content-center">
                  <Button type="submit" className="btn button-search me-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button className="btn button-cancel" type="button" onClick={formik.handleReset}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card className="mt-4">
          <CardBody>
            <TableContainer
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
              className="custom-header-css"
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default ManagerAppraisal;
